import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'mui-rff';

import Grid from '@material-ui/core/Grid';

const SeoBlockCta = ({ blockName, onBlur }) => {
	return (
		<>
			<Grid item xs={12} md={6}>
				<TextField
					name={`${blockName}.label`}
					label="Button label"
					variant="outlined"
					size="small"
					onBlur={onBlur}
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					name={`${blockName}.url`}
					label="URL"
					variant="outlined"
					size="small"
					onBlur={onBlur}
				/>
			</Grid>
		</>
	);
};

SeoBlockCta.propTypes = {
	blockName: PropTypes.string.isRequired,
	onBlur: PropTypes.func.isRequired
};

export default SeoBlockCta;
